import { render } from "./ConsultationProceduresQueueTab.vue?vue&type=template&id=5842e597"
import script from "./ConsultationProceduresQueueTab.vue?vue&type=script&lang=js"
export * from "./ConsultationProceduresQueueTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__